module.exports = __webpack_public_path__ + "static/media/profile.87d30337.svg";